var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterNoResults = function SvgFilterNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    stroke: "transparent",
    strokeWidth: 0
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "none",
    clipPath: "url(#filter-no-results_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    d: "M1.429.357A1.43 1.43 0 0 0 0 1.786v28.571a1.43 1.43 0 0 0 1.429 1.429h13.588a12.8 12.8 0 0 1-.731-4.286c0-3.631 1.505-6.914 3.928-9.251V4.077A5.71 5.71 0 0 0 12.857.36H1.43zM21.786 4.08v11.729a12.857 12.857 0 0 1 18.134 10.24H40V1.786A1.43 1.43 0 0 0 38.571.357H27.143a5.71 5.71 0 0 0-5.357 3.723"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "M22.143 27.5a5 5 0 1 1 10 0 5 5 0 0 1-10 0m5-9.286a9.284 9.284 0 0 0-6.867 15.533 9.29 9.29 0 0 0 11.741 1.659l3.609 3.608a2.143 2.143 0 0 0 3.028-3.028l-3.605-3.612a9.286 9.286 0 0 0-7.906-14.16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "filter-no-results_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgFilterNoResults;